import React from 'react';
import PropTypes from 'prop-types';

export const SvgSlash = ({ width, height }) => (
  <svg width={width || '16px'} height={height || '16px'} viewBox="0 0 16 16" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-109.000000, -330.000000)" stroke="#000000" strokeWidth="2">
        <g transform="translate(105.000000, 326.000000)">
          <circle cx="12" cy="12" r="6.66666667" />
          <path d="M7.28666667,7.28666667 L16.7133333,16.7133333" />
        </g>
      </g>
    </g>
  </svg>
);

SvgSlash.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
